<div class="w-full md:pr-6 md:flex md:mt-4 md:flex-row-reverse">
  <button
    pButton
    type="submit"
    class="w-full md:ml-3 md:w-1/2 p-2 my-2 md:my-0 block rounded-md shadow-none bg-primary text-white font-app-medium text-base"
    [ngClass]="{
      'bg-opacity-50': !enableSubmit,
    }"
    [disabled]="!enableSubmit"
    (click)="displayConfirmationPopup()">
    {{ "contactUsForm.buttons.validate" | translate }}
  </button>
  <button
    pButton
    type="button"
    class="w-full mt-5 md:mt-0 md:w-1/2 p-2 my-2 md:my-0 md:ml-2 block rounded-md shadow-none border border-primary text-primary font-app-medium text-base"
    (click)="onCancel()">
    {{ "contactUsForm.buttons.cancel" | translate }}
  </button>
</div>

